import { parseSelector } from 'vega-event-selector';
import { X, Y } from '../../channel';
import { BRUSH as INTERVAL_BRUSH } from './interval';
import scalesCompiler, { domain } from './scales';
var ANCHOR = '_translate_anchor';
var DELTA = '_translate_delta';
var translate = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'interval' && selCmpt.translate;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var boundScales = scalesCompiler.defined(selCmpt);
    var anchor = name + ANCHOR;
    var _selCmpt$project$hasC = selCmpt.project.hasChannel,
      x = _selCmpt$project$hasC.x,
      y = _selCmpt$project$hasC.y;
    var events = parseSelector(selCmpt.translate, 'scope');
    if (!boundScales) {
      events = events.map(function (e) {
        return e.between[0].markname = name + INTERVAL_BRUSH, e;
      });
    }
    _signals.push({
      name: anchor,
      value: {},
      on: [{
        events: events.map(function (e) {
          return e.between[0];
        }),
        update: '{x: x(unit), y: y(unit)' + (x !== undefined ? ", extent_x: ".concat(boundScales ? domain(model, X) : "slice(".concat(x.signals.visual, ")")) : '') + (y !== undefined ? ", extent_y: ".concat(boundScales ? domain(model, Y) : "slice(".concat(y.signals.visual, ")")) : '') + '}'
      }]
    }, {
      name: name + DELTA,
      value: {},
      on: [{
        events: events,
        update: "{x: ".concat(anchor, ".x - x(unit), y: ").concat(anchor, ".y - y(unit)}")
      }]
    });
    if (x !== undefined) {
      onDelta(model, selCmpt, x, 'width', _signals);
    }
    if (y !== undefined) {
      onDelta(model, selCmpt, y, 'height', _signals);
    }
    return _signals;
  }
};
export default translate;
function onDelta(model, selCmpt, proj, size, signals) {
  var _scaleCmpt$get, _scaleCmpt$get2;
  var name = selCmpt.name;
  var anchor = name + ANCHOR;
  var delta = name + DELTA;
  var channel = proj.channel;
  var boundScales = scalesCompiler.defined(selCmpt);
  var signal = signals.find(function (s) {
    return s.name === proj.signals[boundScales ? 'data' : 'visual'];
  });
  var sizeSg = model.getSizeSignalRef(size).signal;
  var scaleCmpt = model.getScaleComponent(channel);
  var scaleType = scaleCmpt && scaleCmpt.get('type');
  var reversed = scaleCmpt && scaleCmpt.get('reverse'); // scale parsing sets this flag for fieldDef.sort
  var sign = !boundScales ? '' : channel === X ? reversed ? '' : '-' : reversed ? '-' : '';
  var extent = "".concat(anchor, ".extent_").concat(channel);
  var offset = "".concat(sign).concat(delta, ".").concat(channel, " / ").concat(boundScales ? "".concat(sizeSg) : "span(".concat(extent, ")"));
  var panFn = !boundScales || !scaleCmpt ? 'panLinear' : scaleType === 'log' ? 'panLog' : scaleType === 'symlog' ? 'panSymlog' : scaleType === 'pow' ? 'panPow' : 'panLinear';
  var arg = !boundScales ? '' : scaleType === 'pow' ? ", ".concat((_scaleCmpt$get = scaleCmpt.get('exponent')) !== null && _scaleCmpt$get !== void 0 ? _scaleCmpt$get : 1) : scaleType === 'symlog' ? ", ".concat((_scaleCmpt$get2 = scaleCmpt.get('constant')) !== null && _scaleCmpt$get2 !== void 0 ? _scaleCmpt$get2 : 1) : '';
  var update = "".concat(panFn, "(").concat(extent, ", ").concat(offset).concat(arg, ")");
  signal.on.push({
    events: {
      signal: delta
    },
    update: boundScales ? update : "clampRange(".concat(update, ", 0, ").concat(sizeSg, ")")
  });
}